"use client";

import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import Text from "../Text";
import ArrowAccordion from "@/public/assets/images/arrow-circle-left-gradient.svg";

type ItemType = {
  title: string;
  text: string[];
};

type ContentType = {
  items: ItemType[];
};

type AccordionProps = {
  component: {
    type: string;
    content: ContentType;
  };
};

type AccordionItemProps = {
  title: string;
  text: string[];
  isOpen: boolean;
  onClick: () => void;
};

const Accordion = ({ component }: AccordionProps) => {
  const [openTitle, setOpenTitle] = useState<string>(
    component.content.items[0].title
  );

  const handleItemClick = (title: string) => {
    setOpenTitle(openTitle === title ? "" : title);
  };
  return (
    <div className="accordion">
      {component.content.items.map((item) => (
        <AccordionItem
          key={item.title}
          title={item.title}
          text={item.text}
          isOpen={openTitle === item.title}
          onClick={() => handleItemClick(item.title)}
        />
      ))}
    </div>
  );
};

const AccordionItem = ({
  title,
  text,
  onClick,
  isOpen,
}: AccordionItemProps) => {
  return (
    <div
      className={"accordion__item"
        .concat(isOpen ? " accordion__item--active" : "")
        .trim()}
    >
      <button
        onClick={onClick}
        aria-expanded={isOpen}
        className="accordion__button"
      >
        <Text
          element="span"
          elementStyle={isOpen ? "subtitle" : "subtitle-secondary"}
          className="dark-gold accordion__title"
        >
          {title}
          <ArrowAccordion />
        </Text>
        <AnimatePresence initial={false}>
          {isOpen ? (
            <motion.div
              key="content"
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: "auto" },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.18, ease: [0.04, 0.62, 0.23, 0.4] }}
              className="accordion__content"
            >
              {text.map((t) => (
                <Text
                  element="p"
                  elementStyle="body"
                  className="dark-gold"
                  key={t}
                >
                  {t}
                </Text>
              ))}
            </motion.div>
          ) : null}
        </AnimatePresence>
      </button>
    </div>
  );
};

export default Accordion;
